<div
  class="flex items-center justify-center h-screen bg-gradient-to-br from-gray-200 to-gray-500 dark:from-gray-800 dark:to-gray-900 relative overflow-hidden">
  <div class="flex flex-col items-center text-center">
    <div class="w-36 h-36 rounded-full border-4 border-dark-green-300 shadow-lg mb-20">
      <img src="assets/img/favicon.png" alt="Logo" class="p-4" />
    </div>
    <div class="relative bg-white dark:bg-gray-800 shadow-xl rounded-xl p-10 text-center animate-fadeIn flex flex-col items-center">

      <i class="pi pi-exclamation-triangle text-red-500 text-5xl animate-bounce"></i>

      <h2 class="text-2xl font-semibold mt-5 dark:text-white">
        {{ title }}
      </h2>

      <p class="text-gray-500 dark:text-gray-300 mt-3 max-w-sm">
        {{ message }}
      </p>

      <button pButton type="button" [label]="'errorPage.goHome' | translate" icon="pi pi-home"
        class="mt-6 p-button p-button-primary" (click)="goHome()">
      </button>

    </div>
  </div>

</div>